import React, { useState } from "react";
import axios from "axios";

function NewsLetterArea(props) {

  const API_URL = `${process.env.REACT_APP_API_FOLDER}subscribe/`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  const [responseMessage, setResponseMessage] = useState(null);
  const [displayTitle, setDisplayTitle] = useState("Stay up to date");
  const [displayText, setDisplayText] = useState("New workshops and opportunities go out to our mailing list first! Enter your details here, and we'll keep you up to date with news, workshops and opportunities at CAMP.");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) return;

    const payload = new URLSearchParams({
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email: email.trim(),
      ctype: props.ctype,
      item_id: props.item_id,
      tracked_id: props.tracked_id,
    });

    setLoading(true);

    try {
      const { data } = await axios.post(
        API_URL,
        payload,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-API-TOKEN": API_TOKEN
          },
        }
      );

      if (data && typeof data === "string") {
        setResponseMessage(data);
      } else {
        console.error("Unexpected response format:", data);
        setResponseMessage("Unexpected response from the server.");
      }
    } catch (err) {
      console.error("Error during API call:", err);
      setResponseMessage(
        "Sorry, something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (props.ctype !== undefined) {
      setDisplayTitle("There's still a chance...");
      setDisplayText("Add your details to the waiting list and we'll alert you if a place becomes available.");
    }
  }, [props.ctype]);

  return (
    <div className="newsletter-wrapper">
      <div className="container">
        <div className="row align-items-center">
          {/* ---------------------- LEFT SIDE ---------------------- */}
          <div className="col-lg-6">
            <div className="newsletter-side text-center text-lg-start mx-auto mx-lg-0">
              <h2>{displayTitle}</h2>
              <p>
                {displayText}
              </p>

              {responseMessage ? (
                <p className="newsletter-response">{responseMessage}</p>
              ) : (
                <form onSubmit={handleSubmit} id="newsletter-form">
                  <div className="row g-2 mb-2">
                    <div className="col-md-6">
                      <div className="newsletter-form-input">
                        <input
                          type="text"
                          name="first_name"
                          id="newsletter-first-name"
                          placeholder="First name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          autoComplete="given-name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="newsletter-form-input">
                        <input
                          type="text"
                          name="last_name"
                          id="newsletter-last-name"
                          placeholder="Last name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          autoComplete="family-name"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="newsletter-form-input">
                    <input
                      type="email"
                      name="email"
                      id="newsletter-input"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                      required
                    />
                    <button
                      type="submit"
                      className="newsletter-submit"
                      disabled={!firstName || !lastName || !email || loading}
                    >
                      {loading ? "Subscribing..." : "Subscribe"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>

          {/* ---------------------- RIGHT SIDE ---------------------- */}
          <div className="col-lg-6 ">
            <div className="achievement-counter-side">
              <div className="row g-4">
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-tower-cell fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Workshop news</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-door-open fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Opportunities</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-tag fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Discount offers</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  col-md-6">
                  <div className="achievement-box-style-one">
                    <div className="achievement-icon">
                      <i className="fa-solid fa-bolt fa-2xl"></i>
                    </div>
                    <div className="achievement-box-content">
                      <h4>Exciting updates</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsLetterArea;
